import { Component, OnInit } from '@angular/core';
import { AppSettings } from '../../app.constant';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { BatchService } from 'src/app/shared/services/batch.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import {MatSnackBar} from '@angular/material';


@Component({
  selector: 'app-uploadstudent',
  templateUrl: './uploadstudent.component.html',
  styleUrls: ['./uploadstudent.component.css']
})
export class UploadstudentComponent implements OnInit {
    batches:any;
    httpResponseMessage:any;
    selectedFile: File = null;
    errorMessage:any;
    uploadStudentForm:FormGroup;
  constructor(
    private formbuilder:FormBuilder,
    private _batchservice:BatchService,
    private _uploadservice:UploadService,
    private snackBar: MatSnackBar
    ) { }

  ngOnInit() {
   this.uploadStudentForm =this.formbuilder.group( {
    'FK_BatchID':['', Validators],
    'FileUpload1':[''],
     })
     
     this.getAllBatch();
  }

  onFileSelected(event) {
    this.selectedFile = <File> event.target.files[0];
    this.uploadStudentForm.get('FileUpload1').setValue(this.selectedFile);
  }

  getAllBatch() :void  {
    this._batchservice.getAllBatch(AppSettings.API_ENDPOINT+AppSettings.GetAllBatch).subscribe(
     data => {    this.batches=data;
       },
     error => this.errorMessage = <any>error)
  }

  uploadStudentData(post) :void  {
    const formdata = new FormData();
   formdata.append('FileUpload1',this.uploadStudentForm.get('FileUpload1').value);
   formdata.append('FK_BatchID',this.uploadStudentForm.get('FK_BatchID').value);
    this._uploadservice.postStudentFile(AppSettings.API_ENDPOINT+AppSettings.UploadStudentExcel,formdata).subscribe(
      data => {
        this.httpResponseMessage="Student Data Uploaded...."

        this.openSnackBar(this.httpResponseMessage,'');
        this.uploadStudentForm.reset();
        },
      error => this.errorMessage = <any>error)
    }


    durationInSeconds = 2;
    openSnackBar(message: string, action: string) {
      this.snackBar.open(message,action ,{
        duration: 2000,
        verticalPosition: 'bottom'
      });
      }
}

